import React from "react";

export default function UserGuideTileSearchIcon({ size = 47 }) {
  const gid = React.useId().replace(/:/g, "");
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 47 47"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <defs>
        <linearGradient
          id={gid}
          x1="0"
          y1="0"
          x2="46.75"
          y2="46.75"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF7A00" />
          <stop offset="1" stopColor="#FF85C1" />
        </linearGradient>
      </defs>
      <rect width="46.75" height="46.75" rx="23.375" fill={`url(#${gid})`} />
      <path
        d="M20.1454 20.9874C18.4513 20.9874 17.0009 20.3842 15.7943 19.1778C14.5877 17.9714 13.9844 16.5212 13.9844 14.8271C13.9844 13.133 14.5876 11.6859 15.794 10.4858C17.0003 9.28562 18.4506 8.68555 20.1447 8.68555C21.8387 8.68555 23.2891 9.28687 24.4957 10.4895C25.7023 11.6922 26.3056 13.1379 26.3056 14.8267C26.3056 16.5209 25.7024 17.9712 24.4961 19.1777C23.2897 20.3842 21.8394 20.9874 20.1454 20.9874ZM35.699 38.0629L31.5127 33.8766C31.0444 34.1386 30.5435 34.3484 30.0101 34.5058C29.4767 34.6632 28.9099 34.7419 28.3098 34.7419C26.467 34.7419 24.9005 34.0983 23.6105 32.8109C22.3205 31.5236 21.6754 29.9558 21.6754 28.1075C21.6754 26.2593 22.3191 24.6914 23.6064 23.4041C24.8938 22.1168 26.4616 21.4731 28.3098 21.4731C30.1581 21.4731 31.7259 22.1182 33.0133 23.4082C34.3006 24.6982 34.9442 26.2646 34.9442 28.1075C34.9442 28.7076 34.8655 29.2744 34.7081 29.8078C34.5507 30.3412 34.3409 30.8421 34.0789 31.3104L38.2652 35.4967L35.699 38.0629ZM28.3052 31.0981C29.1413 31.0981 29.8495 30.8095 30.4299 30.2322C31.0103 29.6549 31.3005 28.9483 31.3005 28.1122C31.3005 27.2761 31.0118 26.5679 30.4345 25.9875C29.8572 25.4071 29.1506 25.1169 28.3145 25.1169C27.4784 25.1169 26.7702 25.4056 26.1898 25.9829C25.6094 26.5601 25.3192 27.2668 25.3192 28.1029C25.3192 28.939 25.6079 29.6472 26.1852 30.2276C26.7625 30.8079 27.4691 31.0981 28.3052 31.0981ZM20.9177 22.4012C19.6314 23.9387 18.9623 25.7339 18.9105 27.7869C18.8587 29.84 19.3853 31.6806 20.4903 33.3086H8.48438V28.7935C8.48438 27.8947 8.71479 27.0619 9.17562 26.2953C9.63644 25.5286 10.2624 24.9475 11.0536 24.5519C12.2353 23.9431 13.6598 23.4098 15.3273 22.952C16.9947 22.4941 18.8582 22.3106 20.9177 22.4012Z"
        fill="white"
      />
    </svg>
  );
}
